export default "__VITE_ASSET__XDWFMDYh__"